import Vue from 'vue'
import SvgIcon from '../modules/activity/components/SvgIcon.vue'
// import { language_code as language_code_all } from '@activity/common/lang.config.server.js'

/**
 *   通过URL获取用户访问的链接的语言，并改写path
 */
function detect_url_lang() {
  // // const p = this.path;
  // const p = window.location.pathname
  // window.KLK_LANG = 'en'
  // window.KLK_LANG_PATH = ''
  // var langs = language_code_all['F_LANG']
  // for (var i = 0, len = langs.length; i < len; i++) {
  //   var lang = langs[i]
  //   var reg = new RegExp('^/' + lang + '/')
  //
  //   if (lang == 'en') {
  //     continue
  //   }
  //   //其他语言的时候
  //   if (reg.test(p)) {
  //     window.KLK_LANG = lang
  //     window.KLK_LANG_PATH = window.klk_lang + '/'
  //     //修改path,然后保存到klk_lang
  //     // this.path = p.replace(new RegExp("^/" + this.klk_lang), "");
  //     break
  //   }
  // }
  window.KLK_LANG = localStorage.language || 'en'
  window.KLK_LANG_PATH = ['en', ''].includes(window.KLK_LANG) ? '' : window.KLK_LANG + '/'
}

export async function registerUtils(ctx) {
  Vue.prototype.copy = _.cloneDeep
  detect_url_lang()

  // localstorage目前有问题
  // window.KLK_LANG = window.localStorage.getItem('language') || 'en';
  // window.KLK_LANG_PATH = window.klk_lang + "/";

  // https://webpack.js.org/guides/dependency-management/#context-module-api
  const requireAll = (requireContext) => requireContext.keys().map(requireContext)
  const req = require.context('../assets/svg-icons', false, /\.svg$/)
  requireAll(req)
  // 引入 svg-icon
  Vue.component('svg-icon', SvgIcon)
}
const localesMaps = [
  {
    collection_id: '2',
    color: '#BFBFBF',
    id: '12',
    token: 'text-color-light',
    value: 'color-black-25'
  },
  {
    collection_id: '2',
    color: '#8C8C8C',
    id: '11',
    token: 'text-color-secondary',
    value: 'color-black-45'
  },
  {
    collection_id: '2',
    color: '#262626',
    id: '10',
    token: 'text-color-normal',
    value: 'color-black-85'
  },
  {
    collection_id: '2',
    color: '#0091FF',
    id: '6',
    token: 'text-color-primary',
    value: 'color-blue'
  },
  {
    collection_id: '2',
    color: '#36B37E',
    id: '7',
    token: 'text-color-success',
    value: 'color-green'
  },
  {
    collection_id: '2',
    color: '#FF5630',
    id: '9',
    token: 'text-color-error',
    value: 'color-red'
  },
  {
    collection_id: '2',
    color: '#FFAB00',
    id: '8',
    token: 'text-color-warning',
    value: 'color-yellow'
  }
]
export const replaceLocalesMap = (str) => {
  if (!str) return ''
  return str.replace(/(color:)([\w\-\s]+);/g, (...args) => {
    let rstr = localesMaps.find((o) => o.token === _.trim(args[2])).color
    return `${args[1]}${rstr};`
  })
}

export const replaceLanguageI18nKey = (key) => {
  const result = key.match(/act_lan_(.+)/)

  if (!result) {
    return key
  }

  const data = {
    pl_PL: '233411',
    cs_CZ: '233413',
    sk_SK: '233414',
    bg_BG: '233415',
    nl_NL: '233416',
    ca_ES: '233412',
    pt_PT: '233417',
    da_DK: '233418',
    sv_SE: '233419',
    fi_FI: '233420',
    nb_NO: '233421',
    el_GR: '233422',
    hu_HU: '233424',
    tr_TR: '233426',
    tl_PH: '233427',
    hi_IN: '233428',
    ta_IN: '233429',
    si_LK: '233430',
    bn_BD: '233431',
    pt_BR: '233432',
    ro_RO: '233434',
    en_AE: '233433'
  }

  return result[1] && Object.keys(data).includes(result[1]) ? data[result[1]] : key
}
